export const getResponsiveStyles = (isLaptopOne, isLaptopTwo) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: isLaptopTwo ? "1rem 5% 2rem" : "3rem 5% 2rem",
  },
  imageContainer: {
    minWidth: isLaptopOne ? "100px" : "627px",
    minHeight: isLaptopOne ? "100px" : "536px",
    backgroundColor: "rgba(153, 108, 254, 0.10)",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imageContainerWithOverflow: {
    minWidth: isLaptopOne ? "100px" : "627px",
    minHeight: isLaptopOne ? "100px" : "536px",
    maxWidth: "800px",
    borderRadius: "8px",
    backgroundColor: "rgba(153, 108, 254, 0.10)",
    overflow: "hidden",
    display: "flex",
    alignItems: "center", 
    justifyContent: "center", 
  },
  contentWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: isLaptopOne ? "column" : "row",
  },
  audioRecorderContainer: {
    width: isLaptopOne ? "100%" : "40%"
  }
});
